import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Table,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

import { BsFillInfoCircleFill } from "react-icons/bs";
import { FaArrowLeft, FaBook, FaClipboard, FaList } from "react-icons/fa";
import { MdOutlineReceiptLong } from "react-icons/md";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const BookingSummaryScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  // const {
  //   selectedItems = [],
  //   companyName = "",
  //   outletAddress = "",
  // } = location.state || {};

  // const totalAmount = selectedItems.reduce(
  //   (sum, item) => sum + item.itemOfferPrice * item.quantity,
  //   0
  // );

  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  return (
    <>
      {" "}
      {/* <FaArrowLeft
        style={{
          color: "green",
          marginRight: "1rem",
          fontSize: "1.8rem",
        }}
        onClick={() => navigate(-1)}
      /> */}
      <div>
        <div className="fixed-header">
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Col xs="auto" className="d-flex align-items-start">
              <div>
                <h4 className="mb-1 header-title">
                  {userInfo?.outletsDetails &&
                    userInfo?.outletsDetails[0]?.companyId?.companyName}
                </h4>
                <small
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                  className="header-subtitle"
                >
                  {" "}
                  {userInfo?.outletsDetails &&
                    userInfo?.outletsDetails[0]?.companyId?.companyCity}
                </small>
                <br />
                <br />
                {!userInfo?.deliveryTo?.includes("undefined") && (
                  <p>Seat - {userInfo?.deliveryTo}</p>
                )}
              </div>
            </Col>{" "}
            {/* <h6
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
              className="text-dark"
            >
              Complete your Booking
            </h6> */}
          </Row>

          <Row style={{ padding: "4px 1rem" }}>
            <Col xs={12} className="delivery-alert">
              Review and Place your Order
            </Col>
          </Row>
        </div>
        {/* <h6 style={{ color: "green", marginTop: "1rem" }}>Order Summary</h6> */}
        <Row
          style={{
            // alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",
            width: "100%",
            margin: "1px auto",
            textAlign: "center",
            // border: "1px solid",
            height: "50vh",
            overflow: "scroll",
            borderRadius: "5px",
          }}
        >
          <Table striped bordered hover>
            <thead
              style={{
                backgroundColor: "rgb(17, 93, 102)",
                border: "0.5px solid rgb(1, 65, 55)",
              }}
            >
              <tr key="table-header"></tr>
              <th>Items</th>
              <th>₹</th>
              {/* <th>Qty</th> */}
              <th>Tax</th>
              <th>Total</th>
            </thead>
            <tbody>
              {Object.values(selectedItems).map((it) => (
                <tr key={it.itemId}>
                  <td style={{ color: "rgb(17, 93, 102)" }}>
                    {it.selectedQuantity}
                    {" x "}
                    {it.itemName}
                    {it.itemSize !== "Single Size" && (
                      <small style={{ fontStyle: "italic" }}>
                        {" "}
                        {it.itemSize}
                      </small>
                    )}
                  </td>

                  <td style={{ color: "rgb(17, 93, 102)" }}>
                    <span style={{ textDecoration: "line-through" }}>
                      {(it.discountAmount > 0 || it.discountPercent > 0) &&
                        (it.itemOriginalPrice * it.selectedQuantity).toFixed(2)}
                    </span>{" "}
                    {userInfo?.outletsDetails[0].separateGst ? (
                      <>{it.itemOfferPrice * it.selectedQuantity.toFixed(2)}</>
                    ) : (
                      <>
                        {(
                          it.totalSellingPrice /
                          (1 + it.gstPercent / 100)
                        ).toFixed(2)}{" "}
                      </>
                    )}
                  </td>
                  {/* <td>{it.selectedQuantity}</td> */}
                  <td style={{ color: "rgb(17, 93, 102)" }}>
                    {userInfo?.outletsDetails[0].separateGst ? (
                      <> {it.gstTax.toFixed(2)}</>
                    ) : (
                      <>
                        {(
                          it.totalSellingPrice -
                          it.totalSellingPrice / (1 + it.gstPercent / 100)
                        ).toFixed(2)}
                      </>
                    )}{" "}
                    <OverlayTrigger
                      trigger="click"
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-${it.itemId}`}>
                          GST: {it.gstPercent}%
                        </Tooltip>
                      }
                      rootClose
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          marginLeft: "5px",
                        }}
                      >
                        <BsFillInfoCircleFill />
                      </span>
                    </OverlayTrigger>
                  </td>
                  <td style={{ color: "rgb(17, 93, 102)" }}>
                    {it.totalSellingPrice.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>
        <Row
          style={{
            margin: "0px",
            padding: "0.5rem auto",
            justifyContent: "center",
            borderBottom: "0.2px solid",
          }}
        >
          {userInfo?.selectedOutletId?.companyId?.separatePlaformFee && (
            <>
              {"Platform Fee 3% - Rs. "}
              {(
                Object.values(selectedItems).reduce(
                  (total, it) => total + it.totalSellingPrice,
                  0
                ) *
                ((userInfo?.selectedOutletId?.companyId?.separatePlaformFee
                  ? userInfo?.selectedOutletId?.companyId?.platformFee
                  : 0) /
                  100)
              ).toFixed(2)}
            </>
          )}
        </Row>
        <Row
          style={{
            margin: "0px",

            paddingTop: "0.5rem",
          }}
        >
          <Col>
            Total with GST <br />
            <br />
            <h6 style={{ color: "black" }}>
              ₹
              {(selectedItems !== null || selectedItems !== undefined) &&
                (
                  Object.values(selectedItems)?.reduce(
                    (total, it) => total + it.totalSellingPrice,
                    0
                  ) +
                  Object.values(selectedItems)?.reduce(
                    (total, it) => total + it.totalSellingPrice,
                    0
                  ) *
                    ((userInfo?.selectedOutletId?.companyId?.separatePlaformFee
                      ? userInfo?.selectedOutletId?.companyId?.platformFee
                      : 0) /
                      100)
                ).toFixed(2)}{" "}
              |{" "}
              {(selectedItems !== null || selectedItems !== undefined) &&
                Object.values(selectedItems)?.reduce(
                  (total, it) => total + it.selectedQuantity,
                  0
                )}{" "}
              Items
            </h6>
          </Col>
          <Col xs="auto">
            <Button
              disabled={
                selectedItems && Object.values(selectedItems)?.length < 1
              }
              className="continue-btn"
              style={{
                fontSize: "1rem",
                padding: "0.8rem",
                backgroundColor: "rgb(47, 177, 197)",
                color: "black",
              }}
              onClick={() => {
                (userInfo?.outletsDetails[0]?.loginRequired &&
                  !userInfo?.token) ||
                (userInfo?.tableDetails?.floor && !userInfo?.token)
                  ? navigate("/login", {
                      state: {
                        redirectTo: "/createOrder",
                      },
                    })
                  : navigate("/createOrder");
              }}
            >
              <strong>CONFIRM ORDER</strong>
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default BookingSummaryScreen;
